import fpComic from "../../../../src/images/fp-comic.png";
import { HashLink } from "../../../../src/components/link";
import * as React from 'react';
export default {
  fpComic,
  HashLink,
  React
};